import { useContext, useEffect } from "react"
import { List } from "./list/Index"
import { Setup } from "./setup/Index"
import { ToolContext } from "../../../../core/context/ToolContext"

import { FeatureIdState } from "../../toolUsage/global/GlobalFcn"
import { CreateFeatureLogs } from "../../global/API"

export const Category = ({match}) => {
    const { setup_state, tool_state } = useContext(ToolContext)
    const { categoryList } = setup_state
    const { __SESSION } = tool_state
    let loc = match.params.params

    const tool_id = process.env.REACT_APP_TID_BIZ;
    
    const SendFeatureLogs = async()=>{
        let body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState('setup')}->2`,
            feature_id: 2,
            feature_name: "category-setup",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2
        }
        await CreateFeatureLogs(body)
    }   

    useEffect(() => {
        SendFeatureLogs()
        //eslint-disable-next-line
    }, [])

    if (loc === 'list') {
        return <List __SESSION={__SESSION}/>
    }else{
        return (
            <>
                <Setup loc={loc} categoryList={categoryList}  __SESSION={__SESSION}/>
            </>
        )
    }
}